import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./styles/global.css";
// // Importing datepicker css
// import "react-datepicker/dist/react-datepicker.css";
import { useUserState } from "./context/user";
import LoadingModal from "./features/common/LoadingModal.js";
import DelErrorNotificationModal from "./features/common/DelErrorNotificationModal.js";
import LoginForm from "./features/loginPage/Login.js";
import PasswordChange from "./features/passwordChangePage/PasswordChange.js";
import DelLandingPage from "./features/landingPage/DelLandingPage.js";
import useSessionValidation from "./hooks/useSessionValidation";

const NotFound = () => {
  const { currentUser } = useUserState();

  // Setting email links
  const fullPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return currentUser ? (
    <Navigate to="/home" replace />
  ) : (
    <Navigate to={`/?next=${encodeURIComponent(fullPath)}`} replace />
  );
};

function App() {
  const { currentUser } = useUserState();

  // Session validation logic
  const SessionValidator = () => {
    useSessionValidation();
    return null;
  };

  return (
    <Router>
      <div className="App">
        <SessionValidator />
        <LoadingModal />
        <DelErrorNotificationModal />
        <Routes>
          <Route
            path="/"
            element={
              currentUser ? (
                (() => {
                  const params = new URLSearchParams(window.location.search);
                  const nextParam = params.get("next");
                  const safeNext =
                    typeof nextParam === "string" && nextParam.startsWith("/")
                      ? nextParam
                      : null;
                  return <Navigate to={safeNext || "/home"} replace />;
                })()
              ) : (
                <LoginForm />
              )
            }
          />
          <Route path="/password_change" element={<PasswordChange />} />
          <Route
            path="/home/*"
            element={
              currentUser ? (
                <DelLandingPage />
              ) : (
                <Navigate
                  to={`/?next=${encodeURIComponent(
                    `${window.location.pathname}${window.location.search}${window.location.hash}`
                  )}`}
                  replace
                />
              )
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
